import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export default class CreateScoreGradeForm {
  public value: number = 0;
  public label: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    label: [
      (v: string) => !!v || 'Label is required',
      (v: string) => v.length >= 3 || 'Label has to be at least 3 characters',
    ],
    value: [
      (v: number) => !!v || 'Value is required',
      (v: number) => v > 0 || 'Value must be positive number',
    ],
  };
}
